// export const useEnv = {
//   env: 'qa',
//   BASE_CARSTAXI_URL: 'https://buddydev.carstaxi.ae/qa/carstaxi'
// }

// if(process.env.REACT_APP_IS_LOCAL === 'true'){
//   Object.assign(useEnv, {env: 'dev', BASE_CARSTAXI_URL: 'http://localhost:3000/dev/carstaxi'})
// }

// if(process.env.NODE_ENV === 'production'){
//   Object.assign(useEnv, {env: 'prod', BASE_CARSTAXI_URL: 'https://makkah.kabi.ae/prod/carstaxi'})
// }
// @ts-ignore

// Safe appConfig access with fallback
const getAppConfig = () => {
  // Check if appConfig is available in window object
  if (typeof window !== "undefined" && (window as any).appConfig) {
    return (window as any).appConfig;
  }

  // Fallback configuration
  console.warn("appConfig not found, using fallback configuration");
  return {
    env: "prod",
    BASE_CARSTAXI_URL: "https://makkah.kabi.ae/prod/carstaxi",

    // env: "qa",
    // BASE_CARSTAXI_URL: "https://buddydev.carstaxi.ae/qa/carstaxi",
  };
};

export const useEnv = getAppConfig();
// export const useEnv = appConfig;
export const BASE_URL = useEnv.BASE_CARSTAXI_URL + "/portal";

//ENDPOINTS FOR APIs
export const authService = useEnv.BASE_CARSTAXI_URL + "/portal/auth";
export const portalService = BASE_URL;
export const maintenanceService = BASE_URL + "/roaster";
export const mediaService =
  useEnv.BASE_CARSTAXI_URL + "/common/document/presigned-url";
export const commonDocument = (documentId) =>
  useEnv.BASE_CARSTAXI_URL + `/common/document/${documentId}`;
